<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'workflows.screens.readPrivacy.title' | translate }}</h2>
    </mat-toolbar>

    <div mat-dialog-content fusePerfectScrollbar>

        <h2>{{ 'workflows.screens.readPrivacy.greeting' | translate:{ firstName: user.firstName } }}</h2>

        <p [innerHTML]="'workflows.screens.readPrivacy.p1' | translate"></p>

        <p [innerHTML]="'workflows.screens.readPrivacy.p2Html' | translate"></p>

        <p>{{ 'workflows.screens.readPrivacy.p3' | translate }}</p>

    </div>

    <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="space-between center">

        <ng-template #saving>
            <span>{{ 'common.saving' | translate }}</span>
            <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
        </ng-template>

        <ng-template #notSaving>
            <span>{{ 'workflows.screens.readPrivacy.ok' | translate }}</span>
        </ng-template>

        <button data-test="B-Defer" type="button" mat-flat-button color="warn" [disabled]="isSaving" (click)="onClickDefer()">
            {{ 'workflows.screens.readPrivacy.deferButton' | translate }}
        </button>

        <button data-test="B-OK" type="button" mat-flat-button color="accent" [disabled]="isSaving" (click)="onClickOK()">
            <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
        </button>

    </div>
</div>
